import { Button, IconButton, Tooltip } from "@mui/material";
import { cmmsTheme } from "@setup/theme/cmms-theme";

type Props = {
	onClick: () => void;
	disabled?: boolean;
	label?: string;
	// Filled square with just the icon, for toolbars with no room for the labelled button.
	iconOnly?: boolean;
};

// Sibling of ExcelButton for anything that opens or prints a PDF. Font Awesome icon, which is
// what the rest of the project uses for PDF (the drawings tables and their context menus).
export const PdfButton = ({
	onClick,
	disabled,
	label = "PRINT PDF",
	iconOnly,
}: Props) => {
	if (iconOnly) {
		return (
			// The span keeps the tooltip working while the button is disabled (a disabled button
			// fires no pointer events of its own).
			<Tooltip title={label}>
				<span>
					<IconButton
						onClick={onClick}
						disabled={disabled}
						aria-label={label}
						sx={cmmsTheme.styles.pdfIconButton}
					>
						<i className="fas fa-file-pdf" style={{ fontSize: 15 }} />
					</IconButton>
				</span>
			</Tooltip>
		);
	}

	return (
		<Button
			fullWidth
			variant="outlined"
			onClick={onClick}
			disabled={disabled}
			// sx, not style: the token carries hover and disabled states as nested selectors.
			sx={cmmsTheme.styles.pdfButton}
		>
			{/* Same filled chip as ExcelButton, colored from the token. */}
			<span
				className="btn-icon"
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					width: 24,
					height: 24,
					borderRadius: 4,
					lineHeight: 1,
				}}
			>
				<i className="fas fa-file-pdf" style={{ fontSize: 15 }} />
			</span>
			{label}
		</Button>
	);
};
